import { useNavigate } from 'react-router-dom';

const EPAYCO_ONBOARDING_DISMISSED_KEY = 'doctor_epayco_onboarding_dismissed';

export const getEpaycoOnboardingDismissedKey = (doctorId) =>
    doctorId ? `${EPAYCO_ONBOARDING_DISMISSED_KEY}_${doctorId}` : EPAYCO_ONBOARDING_DISMISSED_KEY;

const DoctorEpaycoOnboardingModal = ({ onClose, doctorId }) => {
    const navigate = useNavigate();

    const handleGoToConfig = () => {
        if (doctorId) {
            sessionStorage.setItem(getEpaycoOnboardingDismissedKey(doctorId), '1');
        }
        onClose();
        navigate('/doctor/configuracion-citas');
    };

    const handleDismiss = () => {
        if (doctorId) {
            sessionStorage.setItem(getEpaycoOnboardingDismissedKey(doctorId), '1');
        }
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div
                className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-blue-200 p-8 text-center"
                role="dialog"
                aria-modal="true"
                aria-labelledby="epayco-onboarding-title"
            >
                <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-blue-100 flex items-center justify-center">
                    <svg className="w-8 h-8 text-[#1f94c2]" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h2 id="epayco-onboarding-title" className="text-xl font-bold text-gray-800 mb-2">
                    ¡Documentos aprobados!
                </h2>
                <p className="text-gray-600 text-sm mb-4 text-left">
                    Tu perfil documental fue verificado. El siguiente paso es configurar tu <strong>botón de pago ePayco</strong> para que Redplika pueda confirmar tu registro y habilitar tarifas y agenda.
                </p>
                <ol className="text-left text-sm text-gray-600 space-y-2 mb-6 list-decimal list-inside">
                    <li>Ve a Configuración de citas</li>
                    <li>Crea tu cuenta ePayco (mismo correo de Redplika)</li>
                    <li>Guarda tu Account ID</li>
                </ol>
                <button
                    type="button"
                    onClick={handleGoToConfig}
                    className="w-full py-3 px-4 bg-[#1f94c2] hover:bg-[#1a7ba8] text-white font-semibold rounded-xl transition-colors"
                >
                    Ir a Configuración de citas
                </button>
                <button
                    type="button"
                    onClick={handleDismiss}
                    className="mt-3 w-full py-2 px-4 text-gray-600 hover:text-gray-800 text-sm font-medium"
                >
                    Recordármelo después
                </button>
            </div>
        </div>
    );
};

export default DoctorEpaycoOnboardingModal;
